/* eslint-disable camelcase */
import React from "react";
import { PageLayout } from "@themuse/design-system";
import { useAppState } from "hooks/AppContext";

export const JobIndividualPageLayout = (props: React.ComponentProps<typeof PageLayout>) => {
    const { children, ...restProps } = props;
    const { user } = useAppState();
    const pageProps = {
        ...restProps,
        user,
        staticMobileHeader: true
    };

    return (
        <PageLayout {...pageProps}>
            { children }
        </PageLayout>
    );
};
